// extracted by mini-css-extract-plugin
export default {"base":"SelectOption_base__bdFYZ","left-icon-wrapper":"SelectOption_left-icon-wrapper__BhdCx","content":"SelectOption_content__Qho-j"};